module.exports = __webpack_public_path__ + "fonts/icomoon.svg";


//////////////////
// WEBPACK FOOTER
// ./apps/assets/fonts/icomoon.svg?e5bhwo
// module id = 93
// module chunks = 0